// extracted by mini-css-extract-plugin
export default {"config":"PPCgV0aCYGMxQDqHD3RL","config_form":"vpG5K4Z52HXAEbWR9UNJ"};